module.exports = __webpack_public_path__ + "img/mac-calendar.53ba9412.png";